import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import casitaLogoLg from "../../assets/images/casita-logo.svg"
import casitaLogo from "../../assets/images/faviconcopy.ico"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu gt-sidebar">
        {/* <div className="navbar-brand-box">
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={casitaLogo} />
            </span>
            <span className="logo-lg">
              <img src={casitaLogoLg} />
            </span>
          </Link>
        </div> */}
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>

        {/* <div className="sidebar-background"></div> */}
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
